import { render, staticRenderFns } from "./GenieResidentContacts.vue?vue&type=template&id=13971f52&"
import script from "./GenieResidentContacts.vue?vue&type=script&lang=js&"
export * from "./GenieResidentContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports